
/* eslint-disable @typescript-eslint/naming-convention */
export interface MmiAuthDetails {
  access_token: string;
  token_type: string;
  expires_in: number;
  scope: string;
  project_code: string;
  client_id: string;
  // Used for internal purpose
  expire_time: number;
}

